/* istanbul ignore file */
/* eslint-disable max-len */
// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getServerPages = async () => {
  const Components = {};
  if (ssr) {
    Components.Home = (await import('./pages/Home')).Home;
    Components.PurchaseHistory = (
      await import('./pages/PurchaseHistory')
    ).PurchaseHistory;
    Components.SearchResults = (
      await import('./pages/SearchResults')
    ).SearchResults;
    Components.OrderDetails = (
      await import('./pages/OrderDetails')
    ).OrderDetails;
    Components.CancelItems = (await import('./pages/CancelItems')).CancelItems;
    Components.LinkedAccounts = (
      await import('./pages/LinkedAccounts')
    ).LinkedAccounts;
    Components.GuestOrderTracking = (
      await import('./pages/GuestOrderTracking')
    ).GuestOrderTracking;
    Components.Downloads = (await import('./pages/Downloads')).Downloads;
    Components.BusinessTools = (
      await import('./pages/BusinessTools')
    ).BusinessTools;
    Components.Subscriptions = (
      await import('./pages/Subscriptions')
    ).Subscriptions;
  }
  return Components;
};

export const getRoutes = (
  currentRouteName,
  currentRouteComponent,
  serverPages,
) => ({
  purchaseHistory: {
    name: 'PurchaseHistory',
    componentName: 'PurchaseHistory',
    chunk: () => import('./pages/PurchaseHistory'),
    get component() {
      return ssr
        ? serverPages.PurchaseHistory
        : currentRouteName === 'PurchaseHistory'
        ? currentRouteComponent
        : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({
              default: pageModule.PurchaseHistory,
            })),
          );
    },
    path: '/:context?/myaccount/purchase-history',
    prefetch: [],
    channel: null,
  },
  searchResults: {
    name: 'SearchResults',
    componentName: 'SearchResults',
    chunk: () => import('./pages/SearchResults'),
    get component() {
      return ssr
        ? serverPages.SearchResults
        : currentRouteName === 'SearchResults'
        ? currentRouteComponent
        : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({
              default: pageModule.SearchResults,
            })),
          );
    },
    path: '/:context?/myaccount/purchase-history/search-results',
    prefetch: [],
    channel: null,
  },
  orderDetails: {
    name: 'OrderDetails',
    componentName: 'OrderDetails',
    chunk: () => import('./pages/OrderDetails'),
    get component() {
      return ssr
        ? serverPages.OrderDetails
        : currentRouteName === 'OrderDetails'
        ? currentRouteComponent
        : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({
              default: pageModule.OrderDetails,
            })),
          );
    },
    path: '/:context?/myaccount/order-details',
    prefetch: [],
    channel: null,
  },
  cancelItems: {
    name: 'CancelItems',
    componentName: 'CancelItems',
    chunk: () => import('./pages/CancelItems'),
    get component() {
      return ssr
        ? serverPages.CancelItems
        : currentRouteName === 'CancelItems'
        ? currentRouteComponent
        : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({
              default: pageModule.CancelItems,
            })),
          );
    },
    path: '/:context?/myaccount/cancel-items',
    prefetch: [],
    channel: null,
  },
  linkedAccounts: {
    name: 'LinkedAccounts',
    componentName: 'LinkedAccounts',
    chunk: () => import('./pages/LinkedAccounts'),
    get component() {
      return ssr
        ? serverPages.LinkedAccounts
        : currentRouteName === 'LinkedAccounts'
        ? currentRouteComponent
        : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({
              default: pageModule.LinkedAccounts,
            })),
          );
    },
    path: '/:context?/myaccount/linked-accounts',
    prefetch: [],
    channel: null,
  },
  guestOrderTracking: {
    name: 'GuestOrderTracking',
    componentName: 'GuestOrderTracking',
    chunk: () => import('./pages/GuestOrderTracking'),
    get component() {
      return ssr
        ? serverPages.GuestOrderTracking
        : currentRouteName === 'GuestOrderTracking'
        ? currentRouteComponent
        : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({
              default: pageModule.GuestOrderTracking,
            })),
          );
    },
    path: '/:context?/myaccount/guest-order-tracking',
    prefetch: [],
    channel: null,
  },
  downloads: {
    name: 'Downloads',
    componentName: 'Downloads',
    chunk: () => import('./pages/Downloads'),
    get component() {
      return ssr
        ? serverPages.Downloads
        : currentRouteName === 'Downloads'
        ? currentRouteComponent
        : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({
              default: pageModule.Downloads,
            })),
          );
    },
    path: '/:context?/myaccount/downloads',
    prefetch: [],
    channel: null,
  },
  businessTools: {
    name: 'BusinessTools',
    componentName: 'BusinessTools',
    chunk: () => import('./pages/BusinessTools'),
    get component() {
      return ssr
        ? serverPages.BusinessTools
        : currentRouteName === 'BusinessTools'
        ? currentRouteComponent
        : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({
              default: pageModule.BusinessTools,
            })),
          );
    },
    path: '/:context?/myaccount/business-tools',
    prefetch: ['verification'],
    channel: null,
  },
  subscriptions: {
    name: 'Subscriptions',
    componentName: 'Subscriptions',
    chunk: () => import('./pages/Subscriptions'),
    get component() {
      return ssr
        ? serverPages.Subscriptions
        : currentRouteName === 'Subscriptions'
        ? currentRouteComponent
        : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({
              default: pageModule.Subscriptions,
            })),
          );
    },
    path: '/:context?/myaccount/ordersubscription',
    prefetch: ['verification'],
    channel: null,
  },
  home: {
    name: 'Home',
    componentName: 'Home',
    chunk: () => import('./pages/Home'),
    get component() {
      return ssr
        ? serverPages.Home
        : currentRouteName === 'Home'
        ? currentRouteComponent
        : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({ default: pageModule.Home })),
          );
    },
    path: '/:context?/myaccount/home',
    prefetch: [],
    channel: null,
  },
});
